"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var ProtectedRoute_1 = require("../../../ProtectedRoute");
var userSlice_1 = require("../../../../features/user/userSlice");
var AccountDropdown_1 = __importDefault(require("../../../Account/AccountDropdown"));
var Avatar_1 = __importDefault(require("../../../Avatar"));
var loginSlice_1 = require("../../../../features/login/loginSlice");
var AccountDropdownBottomSheet_1 = __importDefault(require("../../../Account/AccountDropdownBottomSheet"));
var deviceHelper_1 = require("../../../../helpers/deviceHelper");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProfileButton = react_1.memo(function (_a) {
    var openAccountList = _a.openAccountList, onDismiss = _a.onDismiss, user = _a.user, open = _a.open;
    var loginModalIsOpen = react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen);
    var displayName = react_redux_1.useSelector(userSlice_1.selectDisplayName);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown },
            loginModalIsOpen && deviceHelper_1.isMobile() ? null : (react_1.default.createElement(Avatar_1.default, { onClick: openAccountList, name: displayName, img: user === null || user === void 0 ? void 0 : user.avatar })),
            open && !deviceHelper_1.isMobile() ? (react_1.default.createElement(ProtectedRoute_1.AuthProtected, null,
                react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: onDismiss },
                    react_1.default.createElement(AccountDropdown_1.default, { openAccount: openAccountList, onClose: onDismiss })))) : ('')),
        !loginModalIsOpen && deviceHelper_1.isMobile() && (react_1.default.createElement(AccountDropdownBottomSheet_1.default, { user: user, displayName: displayName, open: open, onDismiss: onDismiss }))));
});
exports.default = ProfileButton;
